import { Helmet } from "react-helmet-async"
import { DEFAULT_DESCRIPTION, SITE_NAME, SITE_URL } from "../config/seo"

type SeoHelmetProps = {
  title: string
  description?: string
  /** Путь без домена, например `/catalog` или `/category/1` */
  path: string
  noindex?: boolean
}

export function SeoHelmet({ title, description = DEFAULT_DESCRIPTION, path, noindex }: SeoHelmetProps) {
  const normalized = path.startsWith("/") ? path : `/${path}`
  const canonical = `${SITE_URL}${normalized === "//" ? "/" : normalized}`
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  )
}
